<!-- 群活码 -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="新建群活码"> </el-page-header>
    <div class="containerC">
      <div class="step-1" v-if="active == 1">
        <div class="head-title">群活码信息</div>
        <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="12rem">
          <el-form-item label="群活码名称" prop="name">
            <el-input
              style="width: 30rem"
              v-model="form.name"
              placeholder="请填写群活码名称"
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button type="primary" @click="onNext">下一步</el-button>
        </div>
      </div>
      <div class="form" v-if="active == 2">
        <div class="form-head">
          <div class="title">群活码设置</div>
          <div class="instructions help">
            <div class="desc">1. 每个群活码生成的时候最多选择5个群</div>
            <div class="desc">
              <div class="">2. 可以选择生成多个群活码无上限</div>
            </div>
          </div>
        </div>
        <div class="form-container">
          <div class="form-content-cell" v-for="(item, index) in group_chatArray" :key="index">
            <div class="form-content-cell-head">
              <div class="form-content-cell-head-l">群活码{{ index + 1 }}</div>
              <div class="form-content-cell-head-r" v-if="group_chatArray.length > 1">
                <el-button type="text" @click="onDel(index)">删除</el-button>
              </div>
            </div>
            <div class="form-content-cell-content">
              <el-form :ref="'ruleform'" :model="item.form"   :rules="item.rule" label-width="14rem">
                <el-form-item label="新建群名称" prop="title">
                  <el-input
                    style="width: 30rem"
                    v-model="item.form.title"
                    placeholder="请填写新建群名称"
                    maxlength="30"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item label="入群设置" prop="auto_create_room">
                  <el-checkbox v-model="checked">群人数达上限时，自动创建新群</el-checkbox>
                  <span style="display: block;color: #888;">选择群聊人数达到上限后，将以原群主身份自动创建新群</span>
                </el-form-item>
                <el-form-item label="对应客户群" prop="chat">
                  <div class="person">
                    <el-tag
                      v-for="i of item.form.chat"
                      style="margin: rem 1.2rem 0 0"
                      
                      effect="plain"
                      :key="i.id"
                    >
                      <span v-if="i.name"> {{ i.name }} | </span>
                      群主:{{ i.owner_name }}
                    </el-tag>
                  </div>
                  <el-button class="addBtn" icon="el-icon-plus" @click="addGroupChat(index)">前往添加</el-button>
                </el-form-item>
                <el-form-item label="生成的群活码" prop="url">
                  <!-- <el-upload
                    class="avatar-uploader"
                    :action="
                      axios.defaults.baseURL +
                      '/api/Alioss/upload_temp_uploadimg'
                    "
                    :data="upParams"
                    :on-success="handleSuccess"
                    :file-list="item.form.fileList"
                    accept=".jpg,.png"
                    :show-file-list="false"
                  >
                    <img
                      v-if="item.form.url"
                      :src="item.form.url"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">
                      上传企业微信活码，支持jpg/png格式图片。
                    </div>
                  </el-upload> -->
                  <img v-if="item.form.url" :src="urlImg" class="avatar" />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="form-footer">
            <el-button type="primary" icon="el-icon-plus" @click="onAddGroupCode('ruleform')">添加群活码</el-button>
          </div>
        </div>
        <div class="footer">
          <el-button @click="onPrev">上一步</el-button>
          <el-button type="primary" @click="onConfirm">完成</el-button>
        </div>
      </div>
    </div>
    <right-group ref="drawer" :checkbox="checkbox" @handleSelect="handleSelect"></right-group>
  </div>
</template>

<script>
import rightGroup from '@/components/drawer/rightGroup';
export default {
  name: 'setGroupsAdd',
  components: {
    rightGroup
  },
  data() {
    return {
      form: {
        name: ''
      },
      rules: {
        name: [{ required: true, message: '请输入群活码名称', trigger: 'blur' }]
      },
      checkList: [],
      module: '',
      active: 1,
      activity_code_id: '',
      group_chatArray: [],
      upParams: {},
      chatIdList: '', //群id列表
      urlImg: '', //群活码图片地址
      checked: true,
      nameIndex: 0,
      checkbox: false
    }
  },

  computed: {
    index() {
      return this.group_chatArray.length - 1
    }
  },
  mounted() {
    this.initGroupArray()
    this.upParams.account_id = this.tooken.account_id
  },
  methods: {
    async onConfirm() {
      let isValid = true
      for (let index = 0; index < this.group_chatArray.length; index++) {
        this.$refs['ruleform'][index].validate(valid => {
          if (valid) {
            // console.log(valid);
            // this.addLiveCodesTwo();
          } else {
            isValid = false
            console.log('error submit!!')
            return false
          }
        })
      }
      if (isValid) {
        this.addLiveCodesTwo()
      }
    },
    async addLiveCodesTwo() {
      const group_chatArray = this.group_chatArray.map(i => {
        console.log(i)
        const title = i.form.title
        const url = i.form.url
        const chat_id = i.form.chat.map(item => {
          return item.chat_id
        })
        return {
          title,
          url,
          chat_id
        }
      })
      const group_chatArrayJson = JSON.stringify(group_chatArray)
      const params = this.qs.stringify({
        usertoken: this.tooken.usertoken,
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
        activity_code_id: this.activity_code_id,
        media_id: this.media_id,
        url: this.url,
        group_chatArray: group_chatArrayJson
      })
      const { data: res } = await this.axios({
        url: '/crm/GroupLiveCodeTwo/addLiveCodesTwo',
        method: 'POST',
        data: params
      })
      if (res.code == 1) {
        this.$message.success(res.msg)
        this.goBack()
      } else {
        this.$message.error(res.msg)
      }
    },
    onPrev() {
      this.active = 1
    },
    onDel(index) {
      this.group_chatArray.splice(index, 1)
    },
    addGroupChat(index) {
      this.nameIndex = index
      this.module = 'getClientBaseList'
      this.checkbox = true;
      this.isGroup = false
      this.$refs.drawer.open()
    },
    handleSuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          message: response.msg,
          type: 'error'
        })
        return
      }
      this.$message({
        message: response.msg,
        type: 'success'
      })
      this.group_chatArray[this.index]['form']['url'] = response.data.url
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    initGroupArray() {
      this.group_chatArray = [
        {
          form: {
            title: '群活码1',
            chat: [],
            url: ''
          },
          rule: {
            title: [{ required: true, message: '请输入群活码名称', trigger: 'blur' }],
            url: [
              {
                required: true,
                message: '请上传企业微信群活码',
                trigger: 'blur'
              }
            ],
            chat: [{ required: true, message: '请添加对应客户群', trigger: 'blur' }]
          }
        }
      ]
    },
    addGroupArray() {
      this.group_chatArray.push({
        form: {
          title: `群活码${this.group_chatArray.length + 1}`,
          chat: [],
          url: ''
        },
        rule: {
          title: [
            {
              required: true,
              message: '请输入群活码名称',
              trigger: 'blur'
            }
          ],
          url: [
            {
              required: true,
              message: '请上传企业微信群活码',
              trigger: 'blur'
            }
          ],
          chat: [
            {
              required: true,
              message: '请添加对应客户群',
              trigger: 'blur'
            }
          ]
        }
      })
    },
    async onAddGroupCode(formName) {
      this.$refs[formName][this.index].validate(valid => {
        if (valid) {
          this.addGroupArray()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getQrcode() {
      const { data: res } = await this.axios({
        url: '/crm/GroupLiveCodeTwo/qrcode',
        method: 'POST',
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          url: `https://work.weijub.com/h5/#/pages/activity/customer-code?aid=${this.activity_code_id}`
        })
      })
      if (res.code == 1) {
        const d = res.data
        this.media_id = d.media_id
        this.url = d.url
      } else {
        this.$message.error(res.msg)
      }
    },
    async onNext() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { data: res } = await this.axios({
            url: '/crm/GroupLiveCodeTwo/addLiveCodes',
            method: 'POST',
            data: this.qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              name: this.form.name
            })
          })
          if (res.code == 1) {
            this.activity_code_id = res.data.activity_code_id
            this.getQrcode()
            this.active = 2
          } else {
            this.$message.error(res.msg)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    goBack() {
      this.$router.back()
    },
    handleSelect(person) {
      switch (this.module) {
        case 'getClientBaseList':
          this.group_chatArray[this.index].form.chat = person
          break
        default:
          break
      }
      let list
      list = person.map((val) => {
        return val.chat_id
      })
      this.chatIdList = list.join()
      this.getUrl()
    },
    async getUrl() {
      /*当选择的群超过5个时  只能给他展示5个 */
      const idlist = this.chatIdList.split(',')
      if(idlist.length > 5){
        this.$message.info('最多选择5个群')
        for(let item ; this.group_chatArray[0].form.chat.length > 5 ; item++){
            this.group_chatArray[0].form.chat.splice(item,1)
        }
        return
      }
      if (this.chatIdList == '') {
        return
      } else {
        let create
        if (this.checked == true) {
          create = 1
        } else {
          create = 0
        }
        const res = await this.axios({
          url: '/crm/GroupLiveCodeTwo/addJoinWay',
          method: 'POST',
          data: {
            account_id: this.tooken.account_id,
            chat_id: this.chatIdList,
            auto_create_room: create,
            room_base_name: this.group_chatArray[this.nameIndex].form.title
          }
        })
        if (res.data.code == 1) {
          this.urlImg = res.data.data.url
          this.group_chatArray[this.index]['form']['url'] = res.data.data.url
        } else {
          this.$message(res.data.msg)
        }
      }
    },
    async submitForm() {
      let url = '/crm/ActiveCodeGroup/addActiveCode'
      const params = {
        usertoken: this.tooken.usertoken,
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
        name: this.form.name,
        skip_verify: this.form.skip_verify,
        user: this.form.user,
        remark: this.form.remark,
        content: this.form.content
      }
      if (this.$route.query.id) {
        // 编辑
        url = '/crm/ActiveCodeGroup/editActiveCode'
        params.id = this.$route.query.id
      }
      const { data: res } = await this.axios({
        url,
        method: 'POST',
        data: this.qs.stringify(params)
      })
    }
  }
}
</script>
<style scoped>

.containerC {
  background-color: #ffffff;
  border-radius: .8rem;
  padding: 4rem 2rem;
}
.head-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #303133;
  margin-bottom: 1.2rem;
}
.title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #303133;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.help {
  margin-top: 2.4rem;
}

.link {
  margin: 0 .6rem 0 .6rem;
  font-size: 1.4rem;
  font-weight: 500;
  color: #409eff;
  cursor: pointer;
}

.desc-wrap {
  margin: 2.4rem 0 0;
  font-size: 1.4rem;
  color: #909399;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.desc-wrap .main {
  margin: .4rem 0 0 0;
}
.desc-wrap .sub {
  margin: 0 0 0 2.4rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  color: #303133;
  font-size: 1.4rem;
}
.desc-wrap .el-icon-warning {
  margin: .7rem .3rem 0 0;
}
.desc-wrap .sub .desc-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.desc-wrap .sub .desc-box .desc {
  line-height: 2.8rem;
}
.bold {
  font-weight: 600;
  color: #333;
}

.form-container {
  width: 40%;
}

.form-content-cell-head {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
}

.form-content-cell-content {
  padding: 1.6rem 0;
  margin: .6rem 0 1.2rem 0;
  /* background: #f6f6f9; */
  border-radius: .4rem;
}

.footer {
  margin-top: 4rem;
  padding-top: 4rem;
  border-top: .1rem solid #ebeef5;
}
.help{
  padding: 3rem 2rem;
  border-radius: 1rem;
}
::v-deep .el-form--label-left .el-form-item__label{
  text-align: right;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: .1rem dashed #d9d9d9;
  border-radius: .6rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 2.8rem;
  color: #8c939d;
  width: 17.8rem;
  height: 17.8rem;
  line-height: 17.8rem;
  text-align: center;
}
.avatar {
  width: 17.8rem;
  height: 17.8rem;
  display: block;
}
</style>
